import { useEffect, useRef, useState } from 'react';
import { Feature } from './TabbedAnimatedCarousel';
import { AutoplayInterval } from './TabbedAnimatedCarousel.constants';

export type UseDesktopCarouselProps = {
  features: Feature[];
};

export const useDesktopCarousel = ({ features }: UseDesktopCarouselProps) => {
  const currentSlideTimeout = useRef<NodeJS.Timeout | null>(null);
  const [activeFeatureIndex, setFeatureIndex] = useState(0);
  const activeFeature = features[activeFeatureIndex];

  const updateActiveFeatureIndex = (newIndex: number) => setFeatureIndex(newIndex);

  useEffect(() => {
    if (currentSlideTimeout.current) clearTimeout(currentSlideTimeout.current);

    const autoplay = () => {
      const isLastFeature = activeFeatureIndex >= features.length - 1;

      if (isLastFeature) updateActiveFeatureIndex(0);
      else updateActiveFeatureIndex(activeFeatureIndex + 1);
    };

    currentSlideTimeout.current = setTimeout(autoplay, AutoplayInterval);
  }, [activeFeatureIndex]);

  return {
    activeFeatureIndex,
    activeFeature,
    updateActiveFeatureIndex,
  };
};
